export default __webpack_public_path__ + "static/media/Illustration.8ffe819c.png";